import { render, staticRenderFns } from "./SpecificFields.vue?vue&type=template&id=5794571a&scoped=true&"
import script from "./SpecificFields.vue?vue&type=script&lang=js&"
export * from "./SpecificFields.vue?vue&type=script&lang=js&"
import style0 from "./SpecificFields.vue?vue&type=style&index=0&id=5794571a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794571a",
  null
  
)

export default component.exports